module.exports = __webpack_public_path__ + "static/media/m.b04b058c.png";